// extracted by mini-css-extract-plugin
module.exports = {"colors":"'../../variables.css'","sectionHeader":"_2fgoVp3I3mtgAabYw43TrY","sectionControls":"_1iWpWi3dZFm8iRKbX_KYp4","bottomControls":"_1TDTc3f3KwLXOIY2hGtiMd"};